import { RiPulseLine } from '@remixicon/react';

import {
  IconChartBar,
  IconChartLine,
  IconFlag,
  IconLab,
  RolloutIcon,
} from '@spotify/confidence-core-react';

import type { ResourceType } from '../../hooks/useResourceSearch';

export interface ResourceTypeConfig {
  type: ResourceType;
  singularLabel: string;
  pluralLabel: string;
  icon: typeof IconFlag;
}

export const RESOURCE_TYPE_CONFIGS: ResourceTypeConfig[] = [
  {
    type: 'abtest',
    singularLabel: 'A/B test',
    pluralLabel: 'A/B tests',
    icon: IconLab,
  },
  {
    type: 'rollout',
    singularLabel: 'Rollout',
    pluralLabel: 'Rollouts',
    icon: RolloutIcon,
  },
  {
    type: 'analysis',
    singularLabel: 'Analysis',
    pluralLabel: 'Analyses',
    icon: IconChartBar,
  },
  { type: 'flag', singularLabel: 'Flag', pluralLabel: 'Flags', icon: IconFlag },
  {
    type: 'metric',
    singularLabel: 'Metric',
    pluralLabel: 'Metrics',
    icon: IconChartLine,
  },
  {
    type: 'pulse',
    singularLabel: 'Pulse',
    pluralLabel: 'Pulses',
    icon: RiPulseLine,
  },
];

export const RESOURCE_TYPE_CONFIG_MAP = Object.fromEntries(
  RESOURCE_TYPE_CONFIGS.map(c => [c.type, c]),
) as Record<ResourceType, ResourceTypeConfig>;

export const ALL_TYPES = RESOURCE_TYPE_CONFIGS.map(c => c.type);
